import { render, staticRenderFns } from "./TsLockScreen.vue?vue&type=template&id=30ff853e&scoped=true&"
import script from "./TsLockScreen.vue?vue&type=script&lang=js&"
export * from "./TsLockScreen.vue?vue&type=script&lang=js&"
import style0 from "./TsLockScreen.vue?vue&type=style&index=0&id=30ff853e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ff853e",
  null
  
)

export default component.exports